<template>
  <wa-message
    id="trademark-heads-up"
    icon-name="faCircleInfo"
    icon-style="duotone"
    :custom-style="{
      '--fa-secondary-opacity': '1.0',
      '--fa-secondary-color': 'var(--fa-dk-blue)',
      '--fa-primary-color': 'var(--white)',
      '--message-margin': '0 0 var(--spacing-2xl) 0',
      '--message-border-color': 'var(--fa-lt-gravy)'
    }"
  >
    <h3
      slot="title"
      class="h5"
    >
      Heads up!
      <button
        v-if="!isShowingBrandNoticeDetails"
        class="link underline padding-0 margin-0 b"
        style="
          font-weight; var(--font-weight-bold);
          --link-color: initial;
        "
        @click="isShowingBrandNoticeDetails = true"
      >
        {{ noticeTitle }}
      </button>
      <template v-else>{{ noticeTitle }}</template>
    </h3>
    <div
      v-if="isShowingBrandNoticeDetails"
      slot="content"
    >
      <p>
        If you want to use it, you have to ensure that you have the legal right to do so and that you do not infringe any trademark rights. The use of these
        trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.
      </p>

      <p>See the trademark owner for rules about appropriate use of their trademarks.</p>
    </div>
  </wa-message>
</template>

<script>
  export default {
    name: 'IconBrandNotice',

    data() {
      return {
        isShowingBrandNoticeDetails: false,
        noticeTitle: 'This work may be protected as a trademark.'
      }
    }
  }
</script>
